import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getAudit } from "../lib/api";
import { useApi } from "../lib/useApi";
import { TopBar } from "../components/Layout";
import { AuditTable } from "../components/AuditTable";
import { ErrorState, Loading } from "../components/States";

export function AuditPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTenant = searchParams.get("tenant_id") ?? "";
  const [tenantId, setTenantId] = useState(initialTenant);
  const [applied, setApplied] = useState(initialTenant);

  // Keep the URL query in sync so the filter is shareable/bookmarkable.
  useEffect(() => {
    if (applied) setSearchParams({ tenant_id: applied }, { replace: true });
    else setSearchParams({}, { replace: true });
  }, [applied, setSearchParams]);

  const { data, loading, error, reload } = useApi(
    (signal) => getAudit(applied || undefined, signal),
    [applied],
  );
  const rows = data?.audit ?? [];

  return (
    <>
      <TopBar
        crumbs="Audit log"
        actions={
          <button className="btn" onClick={reload} disabled={loading}>
            Refresh
          </button>
        }
      />
      <div className="content">
        <div className="page-head">
          <div>
            <h1>Audit log</h1>
            <div className="sub">Every mutating staff action, newest first (latest 100).</div>
          </div>
        </div>

        <div className="toolbar">
          <label className="field grow">
            <span className="label">Filter by tenant ID</span>
            <input
              type="text"
              value={tenantId}
              onChange={(e) => setTenantId(e.target.value)}
              placeholder="Tenant ULID (leave blank for all)"
              onKeyDown={(e) => {
                if (e.key === "Enter") setApplied(tenantId.trim());
              }}
            />
          </label>
          <button className="btn primary" onClick={() => setApplied(tenantId.trim())}>
            Apply
          </button>
          {applied ? (
            <button
              className="btn"
              onClick={() => {
                setTenantId("");
                setApplied("");
              }}
            >
              Clear
            </button>
          ) : null}
        </div>

        <div className="card">
          <div className="card-body tight">
            {loading ? (
              <Loading label="Loading audit log…" />
            ) : error ? (
              <ErrorState error={error} onRetry={reload} />
            ) : (
              <AuditTable rows={rows} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
